import React from 'react'
import PropTypes from 'prop-types'
import MediaUtilityService from 'common/services/MediaUtilityService'
import map from 'lodash/map'
import get from 'lodash/get'

import './style.css.scss'

const IMAGE_FIT = {
  default: "cover",
  cover: "cover",
  contain: "contain",
  contained: "contain"
}

const SmartVideo = ({ config, className }) => {
  const url = MediaUtilityService.getImageUrl({
    image: config,
    isVideo: true
  })

  const backgroundSize = IMAGE_FIT[config.fit] || IMAGE_FIT.default

  return (
    <video
      style={{backgroundSize: backgroundSize }}
      className={`smart-video ${className}`}
      key={url}
      preload="metadata" autoPlay muted loop data-autoplay data-keepplaying playsInline>
      <source
        src={url}
        type="video/mp4" />
    </video>
  )
}

SmartVideo.propTypes = {
  config: PropTypes.object.isRequired
}

export default SmartVideo
